import React from "react";
import { Outlet } from "react-router-dom";
import { PlatformCategoryProvider } from "@/contexts/PlatformCategoryContext";

const ProductsLayout: React.FC = () => {
  return (
    <PlatformCategoryProvider>
      <Outlet />
    </PlatformCategoryProvider>
  );
};

export default ProductsLayout;
